const store = {
    namespaced: true,
    state() {
        return {
            utms: {
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_term: '',
                utm_content: ''
            },
            utmsLine: ''
        };
    },
    getters: {
        utms: state => state.utms,
        utmsLine: state => state.utmsLine,
        getNotEmptyUtms: state => {
            let utms = state.utms;
            let result = {};

            for (let key in utms) {
                if (utms[key].trim() !== '') {
                    result[key] = utms[key];
                }
            }

            return result;
        }
    },
    mutations: {
        SET_UTMS: (state, data) => {
            state.utms = data;

            let utm_source = data.utm_source != '' ? `utm_source=${data.utm_source}` : '';
            let utm_medium = data.utm_medium != '' ? `&utm_medium=${data.utm_medium}` : '';
            let utm_campaign = data.utm_campaign != '' ? `&utm_campaign=${data.utm_campaign}` : '';
            let utm_term = data.utm_term != '' ? `&utm_term=${data.utm_term}` : '';
            let utm_content = data.utm_content != '' ? `&utm_content=${data.utm_content}` : '';

            state.utmsLine = `${utm_source}${utm_medium}${utm_campaign}${utm_term}${utm_content}`;
        }
    },
    actions: {
        setTheUtms: ({ commit }, data) => commit('SET_UTMS', data)
    }
};

export default store;
